<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <el-form-item label="零件编码:">
                <el-input size="mini" v-model="dataForm.partCode" placeholder="零件编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="零件名称:">
                <el-input size="mini" v-model="dataForm.partName" placeholder="零件名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="国家:">
                <el-input size="mini" v-model="dataForm.country" placeholder="国家" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="mini" v-if="isAuth('sourcing:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%;" :default-expand-all="false" border :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="零件编码">
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
                </el-table-column>
                <el-table-column prop="outsourcingSupplier" header-align="center" align="left" label="外购供应商">
                </el-table-column>
                <el-table-column prop="roundNo" header-align="center" align="right" label="第几轮报价">
                </el-table-column>
                <el-table-column prop="country" header-align="center" align="center" label="国家">
                </el-table-column>
                <el-table-column prop="unitPrice" header-align="center" align="right" label="单价(A)元/个">
                </el-table-column>
                <el-table-column prop="quantity" header-align="center" align="right" label="数量(B)">
                </el-table-column>
                <el-table-column prop="summation" header-align="center" align="right" label="合计(C=A*B)元">
                </el-table-column>
                <el-table-column header-align="center" align="left" label="操作" width="190">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    fetchRfqQuotationOutBuy,
    removeRfqQuotationOutBuy
} from '@/controller/quotation'
import AddOrUpdate from './quotationOutBuy-add-or-update'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                partCode: '',
                partName: '',
                country: ''
            },
            viewFlag: '',
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    components: {
        AddOrUpdate
    },
    // activated() {
    //     this.getDataList()
    // },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchRfqQuotationOutBuy({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm)
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeRfqQuotationOutBuy({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss">
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
